// src/components/PeoplePlan/TheBench/components/WorkflowTable/WorkflowTableRow.js
import React from "react";

const WorkflowTableRow = ({
  employee,
  isSelected,
  onCheckboxChange,
  onEmployeeSelect
}) => {
  const handleRowClick = (e) => {
    // Prevent row click when checkbox is clicked
    if (e.target.type === 'checkbox') {
      return;
    }
    onEmployeeSelect(employee);
  };

  const handleCheckboxClick = (e) => {
    e.stopPropagation();
    onCheckboxChange(employee.user_id, e.target.checked);
  };

  return (
    <tr 
      onClick={handleRowClick}
      className={isSelected ? "selected" : ""}
    >
      <td>
        <input
          type="checkbox"
          checked={isSelected}
          onChange={handleCheckboxClick}
          onClick={(e) => e.stopPropagation()}
        />
        {employee.employee_name || "N/A"}
      </td>
      <td>{employee.mum_name || "No MUM"}</td>
      <td>{employee.workflow_name || "ERROR"}</td>
      <td>{employee.status || "New"}</td>
      <td>{employee.corp || "N/A"}</td>
    </tr>
  );
};

export default WorkflowTableRow;